import "../layouts/default"

window.addEventListener('klaviyoForms', (e) => {
    if (
        e.detail.formId === 'YaAuwv' &&
        e.detail.type === "submit" &&
        typeof fbq === 'function'
    ) {
        fbq('track', 'CompleteRegistration');
    }
})